<template>
  <div class="container">
    <b-row class="clearfix">
      <b-col cols="lg-8 md-12 sm-12" class="float-left">
        <b-img class="mt-1 float-left mr-4" :src="$store.state.fotoUsuario" rounded="circle" width="80px"/>
        <h5 class="pt-2">{{this.$store.state.nombresUsuario}} {{this.$store.state.apellidosUsuario}}</h5>
        <h6 class="pt-0">{{this.$store.state.tipoDocumentoUsuario}} No.: {{this.$store.state.documentoUsuario}}</h6>
        <p class="pt-0 small text-uppercase">#{{this.$store.state.idMatriculaUsuario}} - {{this.$store.state.rolUsuario}}</p>
      </b-col>
      <b-col cols="lg-4 md-12 sm-12" class="float-right">
        <p class="pt-0 small mb-0">GRADO-CURSO</p>
        <p class="mb-1"><strong>{{this.$store.state.cursoUsuario}}</strong></p>
        <p class="mb-0 small">SEDE</p>
        <p class="mb-1"><strong>{{this.$store.state.sedeUsuario}}</strong></p>
      </b-col>
    </b-row>
    <hr>
  </div>
</template>

<script>
  export default {
    name: 'EncabezadoEstudiante'
  }
</script>
